import { Component } from '@angular/core';

@Component({
  selector: 'ui-fields-wrapper',
  standalone: true,
  template: '<ng-content></ng-content>',
  styleUrl: './ui-fields-wrapper.component.scss',
})
export class UiFieldsWrapperComponent {}
